var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagesBoilerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 226,
    viewBox: "0 0 124 226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#757B83",
    d: "M120 12c2.21 0 4 1.79 4 4v206c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V16c0-2.21 1.79-4 4-4h116zm-2 6H6v202h112V18z",
    transform: "translate(-187.000000, -219.000000) translate(114.000000, 197.000000) translate(73.000000, 22.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M6 18H118V220H6z",
    transform: "translate(-187.000000, -219.000000) translate(114.000000, 197.000000) translate(73.000000, 22.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#757B83",
    d: "M17 4H41V15H17z",
    transform: "translate(-187.000000, -219.000000) translate(114.000000, 197.000000) translate(73.000000, 22.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#757B83",
    d: "M19 0H39V8H19z",
    transform: "translate(-187.000000, -219.000000) translate(114.000000, 197.000000) translate(73.000000, 22.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#757B83",
    d: "M93 140c2.21 0 4 1.79 4 4v48c0 2.21-1.79 4-4 4H31c-2.21 0-4-1.79-4-4v-48c0-2.21 1.79-4 4-4h62zm-2 6H33v44h58v-44z",
    transform: "translate(-187.000000, -219.000000) translate(114.000000, 197.000000) translate(73.000000, 22.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M33 146H91V190H33z",
    transform: "translate(-187.000000, -219.000000) translate(114.000000, 197.000000) translate(73.000000, 22.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#757B83",
    d: "M38 159H86V177H38z",
    transform: "translate(-187.000000, -219.000000) translate(114.000000, 197.000000) translate(73.000000, 22.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesBoilerIcon);
export default __webpack_public_path__ + "static/media/images-boiler-icon.34269967b7ddc6325d3b856dd2a57e73.svg";
export { ForwardRef as ReactComponent };